<div *ngIf="isFirstMenuVisible" id="sidebar" [ngClass]="{ 'sidebar': !isCollapsed, 'sidebar-collapsed': isCollapsed }" class="flex flex-col">
    <div id="logo" class="p-4 pe-3">
        <span *ngIf="!isCollapsed" class="text-20px text-brand-500 dark:text-brand-400">Solfium One DEMO</span>
        <img 
            *ngIf="isCollapsed"
            src="../../../../assets/img/solfium/new-logo-solfium-without_text.svg" class="h-8" alt="Logo"
        />
    </div>

    <div id="options" class="flex flex-col py-4 px-3 grow gap-3" [ngClass]="{ 'items-center': isCollapsed }">
        <div class="flex items-center p-2 gap-8" id="one_demo_comercial"
            [ngClass]="{ 'selected': isActive('/one-demo-comercial') }"
            (click)="navigate('/one-demo-comercial')"
            matTooltip="Comercial"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">home</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Comercial
            </span>
        </div>
        <div class="flex items-center p-2 gap-8" id="one_demo_operative"
            [ngClass]="{ 'selected': isActive('/one-demo-operative') }"
            (click)="navigate('/one-demo-operative')"
            matTooltip="Operativo"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">build</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Operativo
            </span>
        </div>
        <div class="flex items-center p-2 gap-8" id="one_demo_environment"
            [ngClass]="{ 'selected': isActive('/one-demo-environment') }"
            (click)="navigate('/one-demo-environment')"
            matTooltip="CO2 y medio ambiente"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">nest_eco_leaf</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                CO2 y medio ambiente
            </span>
        </div>
        <div class="flex items-center p-2 gap-8" id="one_demo_monitoring"
            [ngClass]="{ 'selected': isActive('/one-demo-monitoring') }"
            (click)="navigate('/one-demo-monitoring')"
            matTooltip="Generación y monitoreo"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">monitoring</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Generación y monitoreo
            </span>
        </div>
        <div class="flex items-center p-2 gap-8" id="one_demo_project_detail"
            [ngClass]="{ 'selected': isActive('/one-demo-project-detail') }"
            (click)="navigate('/one-demo-project-detail')"
            matTooltip="Detalle de proyectos"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">featured_play_list</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Detalle de proyectos
            </span>
        </div>
        <div class="flex items-center p-2 gap-8" id="one_demo_map"
            [ngClass]="{ 'selected': isActive('/one-demo-map') }"
            (click)="navigate('/one-demo-map')"
            matTooltip="Mapa de activos"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">location_on</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Mapa de activos
            </span>
        </div>

        <div class="flex items-center p-2 gap-8" id="one_demo_target_net_zero"
            [ngClass]="{ 'selected': isActive('/one-demo-target-net-zero') }"
            (click)="navigate('/one-demo-target-net-zero')"
            matTooltip="Target Net zero"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">target</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Target NetZero
            </span>
        </div>
        <div class="flex items-center p-2 gap-8" id="one_demo_download"
            [ngClass]="{ 'selected': isActive('/one-demo-download') }"
            (click)="navigate('/one-demo-download')"
            matTooltip="Descargas"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">download</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Descargas
            </span>
        </div>
    </div>

    <div id="actions" class="flex flex-col py-4 px-3 gap-3" [ngClass]="{ 'items-center': isCollapsed }">
        <div class="flex items-center p-2 gap-8"
            [ngClass]="{ 'selected': isActive('/one-demo-profile') }"
            (click)="navigate('/one-demo-profile')"
            matTooltip="Perfil"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">account_circle</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Perfil
            </span>
        </div>
        <div class="flex items-center p-2 gap-8" (click)="logout()"
            matTooltip="Cerrar sesión"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">logout</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Cerrar sesión
            </span>
        </div>
    </div>

    <div id="btn" class="flex justify-end py-2 px-3" [ngClass]="{ 'justify-center': isCollapsed }">
        <button class="btnCollapsed" (click)="toggleSidebar()">
            <mat-icon>{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
        </button>
    </div>
</div>

<ng-container *ngIf="isSecondMenuVisible">
    <div class="flex flex-row justify-between items-center px-9 py-3 bg-white dark:bg-neutral-950" border-neutral-100 dark:border-neutral-800>
        <span *ngIf="!isCollapsed" class="text-20px text-brand-500 dark:text-brand-400">Solfium One DEMO</span>
        <button mat-icon-button (click)="showOffcanvas()">
            <mat-icon class="material-symbols-rounded text-neutral-800 dark:text-neutral-100">dehaze</mat-icon>
        </button>
    </div>

    <div class="offcanvas offcanvas-end z-10 bg-white dark:bg-neutral-950 border-neutral-100 dark:border-neutral-800" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasChatLabel" (hidden.bs.offcanvas)="onOffcanvasClose()">
        <div *ngIf="flag_open" class="offcanvas-header justify-end">
            <button mat-icon-button data-bs-dismiss="offcanvas">
                <mat-icon class="material-symbols-rounded text-neutral-800 dark:text-neutral-100">close</mat-icon>
            </button>
        </div>
        <div *ngIf="flag_open" class="offcanvas-body flex flex-col">
            <div id="options" class="flex flex-col py-4 px-3 grow gap-3" [ngClass]="{ 'items-center': isCollapsed }">
                <div class="flex items-center p-2 gap-8" id="one_demo_comercial"
                    [ngClass]="{ 'selected': isActive('/one-demo-comercial') }"
                    (click)="navigate('/one-demo-comercial')"
                    matTooltip="Comercial"
                    matTooltipClass="custom-tooltip"
                    matTooltipPosition="right"
                    [matTooltipDisabled]="!isCollapsed">
                    <mat-icon class="material-symbols-rounded">home</mat-icon>
                    <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                        Comercial
                    </span>
                </div>
                <div class="flex items-center p-2 gap-8" id="one_demo_operative"
                    [ngClass]="{ 'selected': isActive('/one-demo-operative') }"
                    (click)="navigate('/one-demo-operative')"
                    matTooltip="Operativo"
                    matTooltipClass="custom-tooltip"
                    matTooltipPosition="right"
                    [matTooltipDisabled]="!isCollapsed">
                    <mat-icon class="material-symbols-rounded">build</mat-icon>
                    <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                        Operativo
                    </span>
                </div>
                <div class="flex items-center p-2 gap-8" id="one_demo_environment"
                    [ngClass]="{ 'selected': isActive('/one-demo-environment') }"
                    (click)="navigate('/one-demo-environment')"
                    matTooltip="CO2 y medio ambiente"
                    matTooltipClass="custom-tooltip"
                    matTooltipPosition="right"
                    [matTooltipDisabled]="!isCollapsed">
                    <mat-icon class="material-symbols-rounded">nest_eco_leaf</mat-icon>
                    <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                        CO2 y medio ambiente
                    </span>
                </div>
                <div class="flex items-center p-2 gap-8" id="one_demo_monitoring"
                    [ngClass]="{ 'selected': isActive('/one-demo-monitoring') }"
                    (click)="navigate('/one-demo-monitoring')"
                    matTooltip="Generación y monitoreo"
                    matTooltipClass="custom-tooltip"
                    matTooltipPosition="right"
                    [matTooltipDisabled]="!isCollapsed">
                    <mat-icon class="material-symbols-rounded">monitoring</mat-icon>
                    <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                        Generación y monitoreo
                    </span>
                </div>
                <div class="flex items-center p-2 gap-8" id="one_demo_project_detail"
                    [ngClass]="{ 'selected': isActive('/one-demo-project-detail') }"
                    (click)="navigate('/one-demo-project-detail')"
                    matTooltip="Detalle de proyectos"
                    matTooltipClass="custom-tooltip"
                    matTooltipPosition="right"
                    [matTooltipDisabled]="!isCollapsed">
                    <mat-icon class="material-symbols-rounded">featured_play_list</mat-icon>
                    <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                        Detalle de proyectos
                    </span>
                </div>
                <div class="flex items-center p-2 gap-8" id="one_demo_map"
                    [ngClass]="{ 'selected': isActive('/one-demo-map') }"
                    (click)="navigate('/one-demo-map')"
                    matTooltip="Mapa de activos"
                    matTooltipClass="custom-tooltip"
                    matTooltipPosition="right"
                    [matTooltipDisabled]="!isCollapsed">
                    <mat-icon class="material-symbols-rounded">location_on</mat-icon>
                    <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                        Mapa de activos
                    </span>
                </div>

                <div class="flex items-center p-2 gap-8" id="one_demo_target_net_zero"
                    [ngClass]="{ 'selected': isActive('/one-demo-target-net-zero') }"
                    (click)="navigate('/one-demo-target-net-zero')"
                    matTooltip="Target Net zero"
                    matTooltipClass="custom-tooltip"
                    matTooltipPosition="right"
                    [matTooltipDisabled]="!isCollapsed">
                    <mat-icon class="material-symbols-rounded">target</mat-icon>
                    <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                        Target NetZero
                    </span>
                </div>
                <div class="flex items-center p-2 gap-8" id="one_demo_download"
                    [ngClass]="{ 'selected': isActive('/one-demo-download') }"
                    (click)="navigate('/one-demo-download')"
                    matTooltip="Descargas"
                    matTooltipClass="custom-tooltip"
                    matTooltipPosition="right"
                    [matTooltipDisabled]="!isCollapsed">
                    <mat-icon class="material-symbols-rounded">download</mat-icon>
                    <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                        Descargas
                    </span>
                </div>
            </div>

            <div id="actions" class="flex flex-col py-4 px-3 gap-3" [ngClass]="{ 'items-center': isCollapsed }">
                <div class="flex items-center p-2 gap-8"
                    [ngClass]="{ 'selected': isActive('/one-demo-profile') }"
                    (click)="navigate('/one-demo-profile')"
                    matTooltip="Perfil"
                    matTooltipClass="custom-tooltip"
                    matTooltipPosition="right"
                    [matTooltipDisabled]="!isCollapsed">
                    <mat-icon class="material-symbols-rounded">account_circle</mat-icon>
                    <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                        Perfil
                    </span>
                </div>
                <div class="flex items-center p-2 gap-8" (click)="logout()"
                    matTooltip="Cerrar sesión"
                    matTooltipClass="custom-tooltip"
                    matTooltipPosition="right"
                    [matTooltipDisabled]="!isCollapsed">
                    <mat-icon class="material-symbols-rounded">logout</mat-icon>
                    <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                        Cerrar sesión
                    </span>
                </div>
            </div>
        </div>
    </div>    
</ng-container>
